module.exports = __webpack_public_path__ + "img/Johnston-Architects-cabin.d01fba99.jpg";